import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthenticationService } from '../../authentication/authentication.service';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { storedValudationData } from '../../models/urlAuthParams.model';
import { ValuationService } from '../../services/valuation.service';
import { ApiService } from '../../services/api.service';
import { SHARED_IMPORTS } from '../../shared/standalone-imports';

@Component({
  selector: 'app-offer-status',
  templateUrl: './offer-status.component.html',
  styleUrls: ['./offer-status.component.scss'],
  standalone: true,
  imports: [...SHARED_IMPORTS],
})
export class OfferStatusComponent implements OnInit {
  public verificationForm: UntypedFormGroup;
  public faCheck = faCheck;
  public valuationData: any;
  public valuationDetailData: any;

  constructor(
    public fb: UntypedFormBuilder,
    private readonly authService: AuthenticationService,
    private readonly router: Router,
    private readonly ngxService: NgxUiLoaderService,
    private readonly route: ActivatedRoute,
    private readonly valuationService: ValuationService,
    private readonly api: ApiService,
  ) {

    localStorage.setItem('state', '/status');
    this.verificationForm = fb.group({
      code: [null, Validators.required],
    });
  }

  public ngOnInit(): void {
    this.ngxService.start();
    // Get route params used in servcie
    this.route.params.subscribe((routeParams) => {
      // Sync data
      this.valuationService.syncValuationData(routeParams).then(data => {
        this.valuationData = data;
        // Check if verified has been set.
        if (localStorage.getItem('verified') == null) {
          this.router.navigate(['/verificatie']);
        } else {
          // Verified has been set, check time between now and checked.
          if (Number(new Date().getTime()) - Number(localStorage.getItem('verified')) < 900000) {
            // Less than 15 minutes, do something. We are save to do api actions.


            const valuationAuth: storedValudationData = JSON.parse(localStorage.getItem('valuation'));
            this.api.getValuationId(valuationAuth.id).subscribe(data => {
              this.valuationDetailData = data.data
            })
          } else {
            // More than 15 minutes, re-verify.
            this.router.navigate(['/verificatie']);
          }
        }
      }, error => {
        console.error(error);
      })
    });
  }
}
